export default __webpack_public_path__ + "static/ttdh-preview-btn-small-d2967a933f2521da7272b9d2571d7abc.png";